import styled from "styled-components";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import { ColorLabels } from "@/components/editor/utils/use-color";

export const StyledSemicircle = withViewportStyle("svg")`
  path {
    fill: ${({ theme }) => theme.colors[ColorLabels.VISUALS_3]};
  }

  ${({ $viewport }) => $viewport.tablet`
    display: none;
  `}
`;

export const Semicircle = () => (
  <StyledSemicircle
    className="semicircle"
    width={100}
    height={200}
    viewBox="0 0 100 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M100 200C73.4783 200 48.043 189.464 29.2893 170.711C10.5357 151.957 5.95678e-06 126.522 -4.37113e-06 100C-1.4699e-05 73.4784 10.5357 48.043 29.2893 29.2894C48.0429 10.5357 73.4783 1.2047e-05 99.9999 -4.37114e-06L100 100L100 200Z" />
  </StyledSemicircle>
);

export const StyledCircle = withViewportStyle("svg")`
  circle {
    fill: ${({ theme }) => theme.colors[ColorLabels.VISUALS_2]};
  }

  ${({ $viewport }) => $viewport.tablet`
    display: none;
  `}
`;

export const Circle = () => (
  <StyledCircle
    className="circle"
    width={120}
    height={120}
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="60" cy="60" r="60" />
  </StyledCircle>
);

export const StyledQuarterCircle = withViewportStyle("svg")`
  path {
    fill: ${({ theme }) => theme.colors[ColorLabels.VISUALS_2]};
  }

  ${({ $viewport }) => $viewport.tablet`
    display: none;
  `}
`;

export const QuarterCircle = () => (
  <StyledQuarterCircle
    className="quarter-circle"
    width={120}
    height={120}
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 0C66.2742 0 120 53.7258 120 120L0 120L0 0Z" />
  </StyledQuarterCircle>
);

interface HumpProps {
  className?: string;
}

export const Hump = styled(({ className }: HumpProps) => (
  <svg
    viewBox="0 0 200 200"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M0 200L1.19249e-06 100C1.85108e-06 44.7715 44.7715 5.33895e-07 100 1.19249e-06C155.228 1.85108e-06 200 44.7715 200 100L200 200L0 200Z" />
  </svg>
))`
  position: relative;
`;
